import { browser } from '$app/env';
import { persisted } from './persisted';

const keyPrefix = 'autopayPromptDismissed:';

/** Session-scoped, so a dismissal lasts for this sign-in and clears at logout. */
export function autopayPromptDismissed(obligationId: number) {
    return persisted<boolean>(`${keyPrefix}${obligationId}`, false, { storage: 'session' });
}

// persisted() caches a store per key, so a raw sessionStorage.removeItem would still report a dismissal.
export function clearAutopayPromptDismissals() {
    if (!browser) return;

    const dismissed = Object.keys(sessionStorage).filter((key) => key.startsWith(keyPrefix));
    for (const key of dismissed) persisted<boolean>(key, false, { storage: 'session' }).clear();
}
